import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function TabPanels({ children }) {
  const [value, setValue] = React.useState(0);

  const styles = {
    borderBottom: 1,
    borderColor: "divider",
    flex: "1 1 100%",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Box
        sx={{ flex: 1 }}
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </Box>
    );
  }

  const handleChange = (event, newValue) => setValue(newValue);

  return (
    <>
      <Box>
        <Tabs
          selectionFollowsFocus
          sx={styles}
          value={value}
          onChange={handleChange}
        >
          {children.map((child, index) => (
            <Tab
              key={child.key}
              label={child.panelName}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
      {children.map((child, index) => (
        <TabPanel key={child.key} value={value} index={index}>
          {child.panel}
        </TabPanel>
      ))}
    </>
  );
}
